module.exports = __webpack_public_path__ + "img/second-0.f7f34efa.webp";